import { render, staticRenderFns } from "./ArticlesNode.vue?vue&type=template&id=061c2b8f&"
import script from "./ArticlesNode.vue?vue&type=script&lang=js&"
export * from "./ArticlesNode.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesNode.vue?vue&type=style&index=0&id=061c2b8f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports